import step from 'store/modules/mini/step';
import age from 'store/modules/mini/age';
import lifeExpectancy from 'store/modules/mini/lifeExpectancy';
import lossOfPension from 'store/modules/mini/lossOfPension';
import inflation from 'store/modules/mini/inflation';
import interpolatedMultipliers from 'store/modules/mini/interpolatedMultipliers';
import period from 'store/modules/mini/period';
import pension from 'store/modules/mini/pension';
import earnings from 'store/modules/mini/earnings';
import lossOfEarnings from 'store/modules/mini/lossOfEarnings';
import interest from 'store/modules/mini/interest';
import tableDiscounts from 'store/modules/mini/tableDiscounts';
import retirementAge from 'store/modules/mini/retirementAge';
import dependency from 'store/modules/mini/dependency';
import care from 'store/modules/mini/care';
import meso from 'store/modules/mini/meso';

// Initial State
const state = {

};

// Getters
const getters = {

};

// Actions
const actions = {

};

// Mutations
const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        step,
        age,
        inflation,
        interpolatedMultipliers,
        lifeExpectancy,
        period,
        pension,
        interest,
        tableDiscounts,
        retirementAge,
        earnings,
        dependency,
        care,
        meso,
        lossOfEarnings,
        lossOfPension
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/index.js